"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const detail_vue_1 = __importDefault(require("./detail.vue"));
const HeaderTop_vue_1 = __importDefault(require("@/components/HeaderTop/HeaderTop.vue"));
const productDetail_1 = require("@/api/productDetail");
const brand_1 = require("@/api/brand");
const store_1 = require("@/store");
let Brand = class Brand extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : '';
        this.imgList = [require('@/assets/avatar.png'), require('@/assets/avatar.png')];
        this.brandChecked = [];
        this.typeChecked = [];
        this.brandList = [];
        this.typeList = [];
        this.dataList = [];
        this.pageNo = 1;
        this.pageSize = 20;
        this.currentPage = 1;
        this.total = 0;
        this.hoverIndex = 0;
        this.selectType = false;
        this.firstType = '';
        this.sortType = '';
        this.open = false;
        this.params = {
            content: this.appSearch,
            country: '',
            id: '',
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            parentId: '',
            brandName: '',
            sortProperty: '',
            sort: 1,
            loginToken: this.userInfo.loginToken
        };
    }
    reSet() {
        this.params.id = '';
        this.getList(this.params);
        this.setSecondCategory('');
        this.setFirstCategory('');
    }
    onSubmit() {
    }
    handleTabClick(item) {
        item.label === '价格' ? this.params.sortProperty = 'actualPrice' : item.label === '评分' ? this.params.sortProperty = 'score' : item.label === '销量' ? this.params.sortProperty = 'salesNum' : this.params.sortProperty = '';
        this.getList(this.params);
    }
    upByPrice(type) {
        this.params.sort = 0;
        //1 综合 2销量 3价格 4评分
        if (type == 1) {
            this.params.sortProperty = '';
        }
        else if (type == 2) {
            this.params.sortProperty = 'salesNum';
        }
        else if (type == 3) {
            this.params.sortProperty = 'actualPrice';
        }
        else if (type == 4) {
            this.params.sortProperty = 'score';
        }
        this.getList(this.params);
    }
    downByPrice(item) {
        this.params.sort = 1;
        this.params.sortProperty = 'actualPrice';
        this.getList(this.params);
    }
    sortChange() { }
    getList(data) {
        productDetail_1.productList(data).then((res) => {
            this.dataList = res.list.list;
            this.pageNo = res.list.pageNo;
            this.pageSize = res.list.pageSize;
            this.total = res.list.totalCount;
            this.brandList = res.brands;
            document.querySelector('meta[name="keywords"]').setAttribute('content', res.tkd.keywords);
            document.querySelector('meta[name="description"]').setAttribute('content', res.tkd.description);
            document.title = res.tkd.title;
        });
    }
    checkedBrand(brandName) {
        this.params.brandName = brandName;
        this.getList(this.params);
    }
    showType() {
        this.hoverIndex = 1;
        this.selectType = !this.selectType;
    }
    currentIndex(index, label) {
        this.hoverIndex = index;
        this.firstType = label;
    }
    setFirst(id, label) {
        // console.log('88')
        // console.log(label)
        this.setFirstCategory(label);
        this.setSecondCategory('');
        this.params.id = id;
        this.getList(this.params);
    }
    setSecond(id, label) {
        this.setSecondCategory(label);
        this.setFirstCategory(this.firstType);
        this.selectType = false;
        this.params.id = id;
        // this.params.content = this.firstCategory
        this.getList(this.params);
    }
    handleSizeChange(val) {
        this.params.pageSize = val;
        this.getList(this.params);
    }
    handleCurrentChange(val) {
        this.params.pageNo = val;
        this.getList(this.params);
    }
    mounted() {
        this.params.content = this.appSearch ? this.appSearch : sessionStorage.getItem('searchWord');
        this.params.id = this.$route.params.id;
        if (this.params.id === 'all')
            this.params.id = '';
        if (this.params.id.includes("=")) {
            this.params.brandName = this.params.id.split('=')[1];
            this.params.id = '';
        }
        this.getList(this.params);
        // 品牌列表
        // getBrandList({ pageNo: 1, pageSize: 2000 }).then(res => {
        //   this.brandList = res
        // })
        // 分类列表
        brand_1.getTypeList({}).then(res => {
            this.typeList = res;
        });
    }
};
__decorate([
    store_1.AppModule.State
], Brand.prototype, "firstCategory", void 0);
__decorate([
    store_1.AppModule.State
], Brand.prototype, "secondCategory", void 0);
__decorate([
    store_1.AppModule.State
], Brand.prototype, "allTypes", void 0);
__decorate([
    store_1.AppModule.State
], Brand.prototype, "appSearch", void 0);
__decorate([
    store_1.AppModule.Mutation
], Brand.prototype, "setFirstCategory", void 0);
__decorate([
    store_1.AppModule.Mutation
], Brand.prototype, "setSecondCategory", void 0);
__decorate([
    store_1.AppModule.Mutation
], Brand.prototype, "setAppSearch", void 0);
Brand = __decorate([
    vue_property_decorator_1.Component({
        components: { detail: detail_vue_1.default, HeaderTop: HeaderTop_vue_1.default, FooterBottom: () => Promise.resolve().then(() => __importStar(require('@/components/FooterBottom/Foot.vue'))) }
    })
], Brand);
exports.default = Brand;
